/**
 * Whether the page is out of sight: the phone locked, or another app or tab
 * in front. Read when asked: nothing listens for it changing.
 */
export const isPageHidden = () => typeof document !== 'undefined' && document.visibilityState === 'hidden';
